import { Languages } from "../LanguageContext";

const translations = {
  [Languages.English]: {
    goBack: "Go back",
    youAreHere: "You are here:",
  },
  [Languages.German]: {
    goBack: "Zurück",
    youAreHere: "Sie sind da:",
  },
};

export { translations };
